import { render } from "./addPriceRuleModal.vue?vue&type=template&id=505460cb&scoped=true&ts=true"
import script from "./addPriceRuleModal.vue?vue&type=script&lang=ts"
export * from "./addPriceRuleModal.vue?vue&type=script&lang=ts"

import "./addPriceRuleModal.vue?vue&type=style&index=0&id=505460cb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505460cb"]])

export default __exports__